import $ from 'jquery'
import { isNumber, isPresent } from '../core/typescript/guards'
import { pushDataLayerAddToCartEvent } from '../core/data-layer/add-to-cart'

const SAMPLES_NO = '[js-samples-no]'
const ITEM_ACTIVE = '[js-sample-item].active'
const SAMPLES_TOTAL = '[js-samples-total]'
const ITEM = '[js-sample-item]'
const SELECT_ALL = '[js-sample-select-all]'
const CLEAR_ALL = '[js-sample-clear-all]'
const ADD_TO_CART = '[js-samples-atc]'
const ADD_TO_CART_SHOPAY = '[js-samples-shopay]'

const calculateSamples = () => {
  const samplesNo = $(ITEM_ACTIVE).length
  $(SAMPLES_NO).text(samplesNo)

  /**
   * jQuery .get() method converts a jQuery collection into a regular array
   */
  const samplesPrice: number = $(ITEM_ACTIVE)
    .map(function (_, item): number {
      return parseFloat($(item).attr('price') || 'no-price')
    })
    .get()
    .filter(isNumber)
    .reduce((acc, price) => {
      return acc + price
    }, 0)

  const samplesTotal = '$' + samplesPrice / 100

  $(SAMPLES_TOTAL).text(samplesTotal)

  if (samplesNo > 0) {
    $(ADD_TO_CART).prop('disabled', false)
    $(ADD_TO_CART_SHOPAY).prop('disabled', false)
  } else {
    $(ADD_TO_CART).prop('disabled', true)
    $(ADD_TO_CART_SHOPAY).prop('disabled', true)

  }
}

export const init = async function (): Promise<void> {
  // on sample item click
  $(ITEM).on('click', function () {
    $(this).toggleClass('active')
    calculateSamples()
  })

  // select all samples
  $(SELECT_ALL).on('click', function () {
    $(ITEM).addClass('active')
    calculateSamples()
  })

  // deselect all samples
  $(CLEAR_ALL).on('click', function () {
    $(ITEM).removeClass('active')
    calculateSamples()
  })

  $(ADD_TO_CART).on('click', function () {
    handleAddToCart('/cart');
  });

  $(ADD_TO_CART_SHOPAY).on('click', function () {
    handleAddToCart('https://www.reggioregister.com/checkout?payment=shop_pay');
  });

  function handleAddToCart(redirectUrl) {
    type Item = { id: string; quantity: number };

    const items: Item[] = $(ITEM_ACTIVE)
      .map(function (_, item): Item | null {
        const variantId = $(item).attr('variant-id');

        if (variantId == null) {
          return null;
        }

        return { id: variantId, quantity: 1 };
      })
      .get()
      .filter(isPresent);

    const data = { items: items };

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/cart/add.js',
      data: data,
      async: false,
      success: () => {
        window.location.replace(redirectUrl);
      }
    });

    type GaFormattedItem = {
      item_id: string;
      item_name: string;
      price: number;
      quantity: number;
    };

    let count = items.length;
    let price = 9;

    if (count > 3 && count <= 6) {
      price = 11;
    } else if (count > 6) {
      price = 13;
    }

    const pricePerSample = Math.round((price / count) * 100) / 100;

    const gaFormattedItems: GaFormattedItem[] = $(ITEM_ACTIVE)
      .map((idx, item): GaFormattedItem => {
        const $item = $(item);
        const item_id = $item.attr('variant-id');
        const item_name = `Color Sample: ${$item.find('.Samples-label').text().trim()}`;

        return {
          item_id,
          item_name,
          price: pricePerSample,
          quantity: 1,
        };
      })
      .get();

    pushDataLayerAddToCartEvent(gaFormattedItems);
  }
}
